import { getAddress, isAddress } from "viem"

export const HL_WITHDRAW_FEE_USDC = 1
export const HL_BUILDER_FEE = 70 // 7 bps; HL uses tenths of basis points (1 unit = 0.001%)
export const HL_MARKET_SLIPPAGE = 0.03 // 3% for IoC market orders
// HL enforces a $10 notional minimum on every order (size × price),
// regardless of asset or leverage. We add $1 of slack so a price tick
// between input and submission doesn't push a borderline order under.
// https://hyperliquid.gitbook.io/hyperliquid-docs/trading/order-types#minimum-order-size-and-tick-size
export const HL_MIN_ORDER_VALUE_USD = 11
export const HL_MAINTENANCE_MARGIN_RATIO = 0.03
export const HL_WITHDRAW_STATUS_POLL_MS = 2_000
export const HL_WITHDRAW_STATUS_MAX_ATTEMPTS = 300
export const HL_MAX_MARKETS = 200

export const HL_V1_MARKETS = [
  "BTC",
  "ETH",
  "SOL",
  "NEAR",
  "DOGE",
  "XRP",
  "AVAX",
  "LINK",
  "TRX",
  "ADA",
  "HYPE",
  "SUI",
  "PEPE",
  "WIF",
  "ONDO",
] as const
export type HLMarketName = (typeof HL_V1_MARKETS)[number]

// Getter functions to avoid module-level process.env reads (SSR safety)
export function isHLTestnet(): boolean {
  return process.env.NEXT_PUBLIC_HL_TESTNET === "true"
}

export function getHLBuilderAddress(): `0x${string}` | undefined {
  const raw = process.env.NEXT_PUBLIC_HL_BUILDER_ADDRESS?.trim()
  return raw && isAddress(raw) ? getAddress(raw) : undefined
}

export function getHLBuilderParams():
  | { b: `0x${string}`; f: number }
  | undefined {
  const address = getHLBuilderAddress()
  return address ? { b: address, f: HL_BUILDER_FEE } : undefined
}
